<template>
  <div>
    <div
      v-if="showLink"
      class="d-flex align-items-center mx-xs gap-1 mb-lg">
      <span
        v-if="prefix"
        class="pe-xxs my-xxs text-gray text-nowrap semi-bold">
        {{ prefix }}
      </span>
      <base-input
        class="input"
        :class="{'highlight': highlight }"
        read-only
        :model-value="displayLink"/>
    </div>
    <div
      class="d-flex flex-column flex-md-row gap-lg justify-content-center mx-xs ">
      <BaseButton
        class="w-100"
        primary
        :text="showConfirmation ? 'Copied': 'Copy link'"
        :disabled="false"
        @click="copyLink">
        <template #icon>
          <svg-link
            v-if="!showConfirmation"
            class="me-xxs"
            height="16"
            width="16"/>
          <svg-check
            v-if="showConfirmation"
            class="check scale"
            height="16"
            width="16"/>
        </template>
      </BaseButton>
      <BaseButton
        v-if="showCustomizeLinkButton"
        class="w-100"
        :text="editing ? 'Cancel' : 'Customize link'"
        :variant="isMobile ? 'text-link' : 'secondary'"
        @click="customizeLink"/>
    </div>
  </div>
</template>

<script>
import BaseInput from '../BaseInput'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import SvgLink from '@/components/global/svg/SvgLink.vue'
import SvgCheck from '@/components/global/svg/SvgCheck.vue'
import useScreenSize from '@shared/composables/screenSize.js'


export default {
  name: 'CopyLink',
  components: {
    BaseInput,
    BaseButton,
    SvgLink,
    SvgCheck
  },
  props: {
    prefix: {
      type: String,
      default: ''
    },
    showLink: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: false
    },
    displayLink: {
      type: String,
      required: true
    },
    fullLink: {
      type: String,
      required: true
    },
    highlight: {
      type: Boolean,
      default: false
    },
    buttonVariant: {
      type: String,
      default: 'primary'
    },
    buttonText: {
      type: String,
      default: 'Copy link'
    },
    confirmationText: {
      type: String,
      default: 'Copied!'
    },
    showCustomizeLinkButton: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { isMobile } = useScreenSize()

    return {
      isMobile
    }
  },
  data () {
    return {
      showConfirmation: false,
      editing: false
    }
  },
  computed: {
    buttonClassMargin () {
      const routePath = this.$route.path
      return routePath.includes('profile') ? 'mt-0' : 'mt-2'
    }
  },
  methods: {
    copyLink () {
      navigator.clipboard.writeText(this.fullLink)
      this.showConfirmation = true
      this.$emit('copy-link-click')
      setTimeout(() => {
        this.showConfirmation = false
      }, 5000)
    },
    customizeLink () {
      this.editing = true
      this.$emit('customize-link-click')
    }
  }
}
</script>

<style lang="scss" scoped>

  .scale {
    @include scale-up-down-animation;
  }

  .input {
    margin: 10px 0 !important;
    &.highlight :read-only {
      color: $plum;
      font-weight: $font-weight-semibold;
      background-color: white;
    }
  }

  .check {
    stroke-width: 4px;
    margin-left: 6px;

    transform-origin: 50% 50%;
    stroke-dasharray: 24;
    stroke-dashoffset: 24;
    animation: stroke .2s ease-in .4s forwards;
  }

  @keyframes stroke {
    100% {
      stroke-dashoffset: 48;
    }
  }
</style>
